import { rServices } from '@/plugins/api';

export default class AddressSpace {
  constructor(space) {
    this.address_id = space.address_id;
    this.id = space.id;
    this.description = space.description || '';
    this.name = space.name;
    this.images = space.images || [];
  }

  async deleteImage(id) {
    const response = await rServices.stages.deleteImage({ args: [id] });
    this.images = this.images.filter((i) => i.id !== id);
    return response;
  }

  async addImages(images) {
    const newImages = (images || []).map((image) => ({
      name: image.file_name || image.name,
      original_name: image.file_name || image.original_name,
    }));
    const { id } = this;
    const args = [
      id,
      {
        images: [...newImages],
      },
    ];
    const { response } = await rServices.address.attachAddressSpaceImages({ args });
    this.images = [
      ...(response?.data?.data?.images || []),
    ];
    return response;
  }
}
